import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.class';
import {BaseMultiplyColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-multiply-color-panel';
import type {RGBA} from '@Utils/color.util';
import {useAppSelector} from '@/hooks';

export function ImageBgMultiplyColorPanel(): ReactElement<any> | null {
  const currentPageObject = useAppSelector(getCurrentPage);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageObject) {
    return null;
  }

  if (currentPageObject.background.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  const onUpdateColor = (multiplyColor: RGBA, undoable = true): void => {
    if ('imageBackgroundItemObject' in currentPageObject.background.details) {
      void currentPage?.background.updateFromObject(
        {
          details: {
            imageBackgroundItemObject: {
              effects: {
                multiplyColor,
              },
            },
          },
        },
        {undoable}
      );
    } else {
      throw new Error('imageBackgroundItemObject does not exist in page background details');
    }
  };

  return <BaseMultiplyColorPanel multiplyColor={currentPageObject.background.details.imageBackgroundItemObject.effects.multiplyColor} onUpdateMultiplyColor={onUpdateColor} />;
}
